(() => {
  const moneyFormat = (cents) => {
    if (window.Shopify?.formatMoney && window.theme?.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(cents / 100);
  };

  const readVariants = (root) => {
    try {
      return JSON.parse(root.querySelector('[data-acqua-spring-variant-data]')?.textContent || '{}');
    } catch (_error) {
      return {};
    }
  };

  const acceptedOffer = (offer, nowSeconds = Math.floor(Date.now() / 1000)) => (
    offer?.eligible === true
    && offer.campaignId === 'acqua-spring-2026-09'
    && offer.currency === 'AUD'
    && typeof offer.generation === 'string'
    && offer.generation.length > 0
    && Number.isSafeInteger(offer.startsAt)
    && Number.isSafeInteger(offer.endsAt)
    && offer.startsAt <= nowSeconds
    && offer.endsAt > nowSeconds
    && Number.isSafeInteger(offer.regularPriceCents)
    && Number.isSafeInteger(offer.salePriceCents)
    && offer.regularPriceCents > offer.salePriceCents
    && offer.salePriceCents > 0
  ) ? offer : null;

  const update = (root, variantId) => {
    if (!root) return null;
    const offer = acceptedOffer(readVariants(root)[String(variantId)]);
    const active = Boolean(offer);
    root.hidden = !active;
    root.classList.toggle('acqua-spring-pricing--active', active);
    root.dataset.selectedVariantId = String(variantId || '');
    const panel = root.querySelector('[data-acqua-spring-panel]');
    if (!active) {
      delete root.dataset.springSaleRegularCents;
      delete root.dataset.springSaleSaleCents;
      delete root.dataset.springSaleCurrency;
      return null;
    }

    root.dataset.springSaleRegularCents = String(offer.regularPriceCents);
    root.dataset.springSaleSaleCents = String(offer.salePriceCents);
    root.dataset.springSaleCurrency = 'AUD';
    panel.dataset.springSaleRegularCents = String(offer.regularPriceCents);
    panel.dataset.springSaleSaleCents = String(offer.salePriceCents);
    panel.dataset.springSaleCurrency = 'AUD';
    root.querySelector('[data-acqua-spring-sale-price]').textContent = moneyFormat(offer.salePriceCents);
    const instalment = root.querySelector('[data-acqua-spring-instalment]');
    if (instalment) instalment.textContent = moneyFormat(offer.salePriceCents / 4);
    const details = root.querySelector('[data-acqua-spring-details]');
    const hasRrpSaving = Number.isSafeInteger(offer.rrpPriceCents)
      && offer.rrpPriceCents > offer.salePriceCents
      && Number.isSafeInteger(offer.savingAmountCents)
      && Number.isSafeInteger(offer.savingPercent);
    details.hidden = !hasRrpSaving;
    if (hasRrpSaving) {
      root.querySelector('[data-acqua-spring-rrp]').textContent = moneyFormat(offer.rrpPriceCents);
      root.querySelector('[data-acqua-spring-saving-amount]').textContent = moneyFormat(offer.savingAmountCents);
      root.querySelector('[data-acqua-spring-saving-percent]').textContent = String(offer.savingPercent);
    }
    return offer;
  };

  const expiryTimers = new WeakMap();

  document.addEventListener('variant-change', (event) => {
    const details = event.target.closest('[data-product-details]');
    const variantId = event.detail?.variant?.id;
    if (!details || !variantId) return;
    const root = details.querySelector('[data-acqua-spring-pricing]');
    const offer = update(root, variantId);
    scheduleExpiry(root);
    document.dispatchEvent(new CustomEvent('acqua:spring-pricing-change', {
      detail: { root, variantId: String(variantId), offer },
    }));
  });

  const linkedProductUrl = (handle, storefrontRoot = '/') => {
    if (!handle) return null;
    const root = storefrontRoot.endsWith('/') ? storefrontRoot : `${storefrontRoot}/`;
    return `${root}products/${encodeURIComponent(handle)}?view=acqua-spring-pricing`;
  };

  const scheduleExpiry = (root) => {
    const priorTimer = expiryTimers.get(root);
    if (priorTimer) clearTimeout(priorTimer);
    const offer = Object.values(readVariants(root)).find((candidate) => Number.isSafeInteger(candidate?.endsAt));
    if (!Number.isSafeInteger(offer?.endsAt)) return;
    const remaining = offer.endsAt * 1000 - Date.now();
    if (remaining <= 0) return;
    const timer = setTimeout(() => {
      const accepted = update(root, root.dataset.selectedVariantId);
      document.dispatchEvent(new CustomEvent('acqua:spring-pricing-change', {
        detail: { root, variantId: String(root.dataset.selectedVariantId), offer: accepted },
      }));
      if (accepted) scheduleExpiry(root);
    }, Math.min(remaining + 50, 2147483647));
    expiryTimers.set(root, timer);
  };

  document.querySelectorAll('[data-acqua-spring-pricing]').forEach((root) => {
    update(root, root.dataset.selectedVariantId);
    scheduleExpiry(root);
  });

  window.AcquaSpringPricing = {
    productView: 'acqua-spring-pricing',
    acceptedOffer,
    linkedProductUrl,
    update,
  };
})();
